import script from "./UserOrganizationsListing.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserOrganizationsListing.vue?vue&type=script&setup=true&lang=ts"

import "./UserOrganizationsListing.vue?vue&type=style&index=0&id=3acdcf4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3acdcf4a"]])

export default __exports__